<app-modal-wrapper ariaRole="dialog" ariaLabelledBy="terms-title" [ariaDescribedBy]="undefined" title="Terms and Conditions">
  <div class="modal-body">
    <app-terms></app-terms>
  </div>
</app-modal-wrapper>
